/* global axios */
import ApiClient from './ApiClient';

// Medidores de pesquisa (CSAT e NPS). A carteira é sub-recurso do medidor porque só existe
// dentro dele — não é uma lista de contatos reaproveitável.
class SurveysAPI extends ApiClient {
  constructor() {
    super('survey_gauges', { accountScoped: true });
  }

  getWallet(id, params = {}) {
    return axios.get(`${this.url}/${id}/wallet`, { params });
  }

  addWalletContacts(id, contactIds) {
    return axios.post(`${this.url}/${id}/add_wallet_contacts`, {
      contact_ids: contactIds,
    });
  }

  removeWalletContacts(id, contactIds) {
    return axios.delete(`${this.url}/${id}/remove_wallet_contacts`, {
      data: { contact_ids: contactIds },
    });
  }

  importFromOwner(id) {
    return axios.post(`${this.url}/${id}/import_from_owner`);
  }
}

export default new SurveysAPI();
